module.exports = __webpack_public_path__ + "static/media/github_logo.75d4c9ec.svg";